import riderMessages from 'core/data-model/constants/validation-messages'

export const checkInvalidPayerOccupationFactorRule = (rule, eligibilities) => {
  const errorMessage =
    eligibilities.payerOccupationFactor === rule.value ? riderMessages.RULE_PAYER_OCCUPATION_FACTOR : ''

  return {
    type: rule.validationType,
    message: errorMessage,
  }
}
